var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrash = function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ED6E6E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M1.6 3.1h12.8m-8 8V6.3m3.2 4.8V6.3m1.6 8H4.8a1.6 1.6 0 0 1-1.6-1.6V3.9a.8.8 0 0 1 .8-.8h8a.8.8 0 0 1 .8.8v8.8a1.6 1.6 0 0 1-1.6 1.6M6.4 3.1h3.2a.8.8 0 0 0 .8-.8v-.8a.8.8 0 0 0-.8-.8H6.4a.8.8 0 0 0-.8.8v.8a.8.8 0 0 0 .8.8"
  })));
};
export default SvgIconTrash;